import { render, staticRenderFns } from "./list.vue?vue&type=template&id=22e10ed6&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=22e10ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e10ed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e10ed6')) {
      api.createRecord('22e10ed6', component.options)
    } else {
      api.reload('22e10ed6', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=22e10ed6&scoped=true&", function () {
      api.rerender('22e10ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/groupBuying/list.vue"
export default component.exports